import styled from 'styled-components';

/* Evidence card: camera frame = proof, plate below = the fact. */
export const Content = styled.div`
  flex: 1;
  min-width: 0;
  max-width: 471px;
  box-sizing: border-box;
  padding: 12px 12px 14px;
  border-radius: 12px;
  background: #1a2429;
  border: 1px solid #2c353d;
  img {
    box-sizing: border-box;
    height: auto;
  }
`;

/* Card header: direction label on the left, the (secondary) re-recognition
   control on the right. */
export const CardHead = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  min-height: 32px;
  margin: 0 0 10px;

  button {
    height: 32px;
    font-size: 13px;
    font-weight: 500;
    padding: 0 12px;
    img {
      width: 15px;
      margin-right: 7px;
    }
  }
`;

export const Title = styled.div`
  margin: 0;
  font-size: 14px;
  font-weight: 600;
  line-height: 1.1;
  letter-spacing: 0.2px;
  color: #e6eaec;
  display: flex;
  align-items: center;
  gap: 8px;

  &::before {
    content: '';
    width: 8px;
    height: 8px;
    border-radius: 999px;
    background: #47b972;
    flex-shrink: 0;
  }
`;

export const PhotoPlace = styled.div`
  border: 1px solid #2c353d;
  background: #10151a;
  border-radius: 10px;
  height: 260px;
  width: 100%;
  margin: 0 0 12px;
  overflow: hidden;
  position: relative;
  cursor: pointer;
  transition: 0.2s opacity ease-in, 0.15s border-color ease-in;
  &:hover {
    opacity: 0.92;
    border-color: #3d4952;
  }
  &.error {
    background: #10151a url('/images/no-photo.png') no-repeat 50%;
    background-size: 100px auto;
  }
  img {
    border-radius: 8px;
  }
`;

export const Refresh = styled.button`
  position: absolute;
  right: 10px;
  top: 10px;
  border: 1px solid rgba(255, 255, 255, 0.08);
  border-radius: 10px;
  width: 36px;
  height: 36px;
  background: rgba(18, 23, 28, 0.72) url('/images/rebut.png') no-repeat 50% 50%;
  background-size: 18px auto;
  backdrop-filter: blur(2px);
  transition: all 0.2s ease-in;
  cursor: pointer;
  &:hover {
    background-color: rgba(71, 185, 114, 0.85);
    border-color: #47b972;
  }
`;
